// Utiliser la même base URL que les autres fichiers (inclut déjà /api)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export interface VintedCategory {
  id: string;
  title: string;
  code: string;
  parent_id?: string;
  children?: VintedCategory[];
}

export interface CategoryTreeResponse {
  categories?: VintedCategory[];
  catalogs?: VintedCategory[];  // AJOUTÉ pour supporter les deux formats
}

export interface CategorySearchResult {
  id: string;
  title: string;
  code: string;
  path: string;
}

export interface CategorySearchResponse {
  results: CategorySearchResult[];
  total: number;
}

class CategoriesApi {
  private baseUrl: string;
  private treeBaseUrl: string;

  constructor() {
    // API_BASE_URL contient déjà /api
    this.baseUrl = `${API_BASE_URL}/categories`;
    // Utiliser le nouveau endpoint pour l'arborescence
    this.treeBaseUrl = `${API_BASE_URL}/categories-tree`;
  }

  async getTree(): Promise<CategoryTreeResponse> {
    // Charge l'arborescence depuis le cache JSON (pas de Humanoid ici, c'est rapide)
    const response = await fetch(`${this.treeBaseUrl}/tree`);
    if (!response.ok) {
      throw new Error(`Failed to fetch categories: ${response.statusText}`);
    }
    return response.json();
  }

  async search(query: string): Promise<CategorySearchResult[]> {
    const response = await fetch(`${this.treeBaseUrl}/search?query=${encodeURIComponent(query)}`);
    if (!response.ok) {
      throw new Error(`Failed to search categories: ${response.statusText}`);
    }
    const data = await response.json();
    return data.results;
  }

  async getCategory(id: string): Promise<VintedCategory> {
    const response = await fetch(`${this.treeBaseUrl}/${id}/info`);
    if (!response.ok) {
      throw new Error(`Failed to fetch category: ${response.statusText}`);
    }
    const data = await response.json();
    return data.category;
  }
}

export const categoriesApi = new CategoriesApi();
